import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { getAdminSettlementsPost } from 'services/fund/settlement'

export default function useSetDeleteSettlement(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: getAdminSettlementsPostPayload) => {
            return getAdminSettlementsPost(payload)
        },
        onSuccess: (data, variable) => {
            refetch()
            toast.success('کاربر با موفقیت حذف شد')
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate }
}
